import { Skeleton } from "@/components/ui/skeleton";

const MarketplaceListItemSkeleton = () => (
  <div className="tibia-border bg-card rounded-lg overflow-hidden flex items-center gap-3 px-3 py-2">
    {/* Image */}
    <Skeleton className="w-12 h-12 rounded flex-shrink-0" />
    {/* Type badge */}
    <Skeleton className="h-5 w-14 rounded flex-shrink-0" />
    {/* Name + details */}
    <div className="flex-1 min-w-0 flex flex-col gap-1">
      <Skeleton className="h-3 w-32" />
      <Skeleton className="h-2 w-20" />
    </div>
    {/* Price */}
    <div className="flex-shrink-0 flex flex-col items-end gap-1">
      <Skeleton className="h-3 w-16" />
      <Skeleton className="h-2 w-12" />
    </div>
    {/* Actions */}
    <div className="flex items-center gap-1 flex-shrink-0 pl-2 ml-1">
      <Skeleton className="h-4 w-4 rounded-full" />
      <Skeleton className="h-4 w-4 rounded-full" />
      <Skeleton className="h-4 w-4 rounded-full" />
    </div>
  </div>
);

export default MarketplaceListItemSkeleton;
